import { render, staticRenderFns } from "./Barangays.vue?vue&type=template&id=ceb74ea8&"
import script from "./Barangays.vue?vue&type=script&lang=js&"
export * from "./Barangays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports